import {
  EPostRegister,
  NUser,
  EPostLogin,
  EGuestLogin,
  RSetState,
  EGetCode,
  EGetWechatCode,
  EGetLoginStatus,
  EBindWechat,
  EPutUserPassword,
  EBindWechatStatus,

} from './constants'

import { postRegist, postLogin, getCode, getWechatCode, getLoginStatus, bindWechat, putUserPassword, guestLogin } from '../services'
import { bindJWTToken } from '../dva16'
import { message } from 'antd'
export default {
  namespace: NUser,
  state: {
    user: null,
    token: '',
    isGetCode: false,
    wechatCode: null,
    bindWechatStatus: null, //是否绑定了微信号
  },
  reducers: {
    [RSetState](state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },
  effects: {
    async [EPostRegister]({ payload }, { call, reducer, select }) {
      let { user, token } = await call(postRegist, payload)
      reducer(RSetState, { user })
      bindJWTToken(token)
      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('k3Token', token)
      window.location.href = '#/'
      // localStorage.setItem('user', JSON.stringify(user))
      // bindJWTToken(token)
    },
    //忘记密码
    async [EPutUserPassword]({ payload }, { call, reducer, select }) {
      let data = await call(putUserPassword, payload)
      message.success('密码修改成功，请登录！')
      window.location.href = '#/login'
    },

    async [EPostLogin]({ payload }, { call, reducer, select }) {
      let { user, token } = await call(postLogin, payload)
      reducer(RSetState, { user })
      bindJWTToken(token)
      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('k3Token', token)
      window.location.href = '#/'
      window.location.reload()
    },
    //游客登录
    async [EGuestLogin]({ payload }, { call, reducer }) {
      let { user, token } = await call(guestLogin)
      reducer(RSetState, { user })
      bindJWTToken(token)
      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('k3Token', token)
      window.location.href = '#/'
      window.location.reload()
    },
    //注册验证码
    async [EGetCode]({ payload }, { call, reducer }) {
      reducer(RSetState, { isGetCode: false })
      let result = await call(getCode, payload)
      console.log('mobile code', result)
      reducer(RSetState, { isGetCode: true })
    },
    //微信登录二维码
    async [EGetWechatCode]({ payload }, { call, reducer }) {
      console.log(payload, 'payload')
      let result = await call(getWechatCode)
      console.log('result', result)
      reducer(RSetState, { wechatCode: result })
    },
    //微信登录状态
    async [EGetLoginStatus]({ payload }, { call, reducer }) {
      const result = await call(getLoginStatus, payload)
      console.log('result', result)
    },
    //微信绑定
    async [EBindWechat]({ payload }, { call, reducer }) {
      const result = await call(bindWechat, payload)
      // console.log(result, 'bbbbbbbbb')
    },


    async [EBindWechatStatus]({ payload }, { call, reducer }) {
      // const result = await call(bindWechat, payload)
      // console.log(result, 'bbbbbbbbb')
      reducer(RSetState, { bindWechatStatus: true })
    },
  },
}
